var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { getResourceService, } from './getResourceService';
export function receiveResourceData(resource, varsOrOptions, input) {
    var receiveOptions = typeof varsOrOptions === 'string' || typeof varsOrOptions === 'number'
        ? { vars: varsOrOptions, data: input }
        : varsOrOptions;
    var data = receiveOptions.data, options = __rest(receiveOptions, ["data"]);
    var _a = __read(getResourceService(resource, options), 2), controller = _a[1];
    controller.receive(data);
}
//# sourceMappingURL=receiveResourceData.js.map